// Gedeelde helpers voor de spel-views (bingo, quiz) — player-picker, scores, toasts.

import { getStore, setPlayer } from '../store.js'
import { setState } from '../api.js'
import { esc } from '../util.js'

export { esc }

export function bingoScores(data, claims) {
  const tiles = new Map((data.bingo ?? []).map(t => [t.id, t]))
  const totals = Object.create(null)
  for (const [tileId, by] of Object.entries(claims)) {
    if (!by) continue
    const tile = tiles.get(tileId)
    if (!tile) continue
    totals[by] = (totals[by] ?? 0) + (tile.points ?? 1)
  }
  return totals
}

export function renderPlayerPick(ctx) {
  const store = getStore()
  const players = ctx.data.meta?.players ?? []
  const current = store.player.name
  return `
    <div class="player-pick">
      <span class="who">Spel als</span>
      <select id="player-select">
        <option value="">— kies —</option>
        ${players.map(p => `<option value="${esc(p)}" ${p === current ? 'selected' : ''}>${esc(p)}</option>`).join('')}
      </select>
    </div>
  `
}

export function renderScoresStrip(ctx) {
  const store = getStore()
  const bingo = bingoScores(ctx.data, store.game.bingo)
  const quiz = store.game.scores ?? {}
  const players = ctx.data.meta?.players ?? []
  const rows = players.map(p => {
    const b = bingo[p] ?? 0
    const q = quiz[p] ?? 0
    const total = b + q
    return `<span class="badge">${esc(p)}: ${total} pt</span>`
  }).join('')
  return `<div class="badge-row" style="margin: 6px 0 14px">${rows}</div>`
}

export function wirePlayerPick(root, onChange) {
  const sel = root.querySelector('#player-select')
  if (!sel) return
  sel.addEventListener('change', async () => {
    const name = sel.value || null
    setPlayer({ name })
    try { await setState({ name }) } catch (e) { console.warn('player-name niet opgeslagen', e) }
    if (typeof onChange === 'function') onChange()
  })
}

export function showToast(root, msg, err) {
  const t = document.createElement('div')
  t.className = 'toast' + (err ? ' err' : '')
  t.textContent = msg
  root.appendChild(t)
  setTimeout(() => t.remove(), 2400)
}
